import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { from, Observable, of } from 'rxjs';
import { IUserStorageAdapter } from './user-storage.interface';

@Injectable({
  providedIn: 'root'
})
export class UserStorageBrowserAdapter implements IUserStorageAdapter {
  constructor(
    private storage: Storage,
  ) {}

  migrateToPrefsIfNeeded(key: string): Observable<void> {
    return of(undefined);
  }

  get<T>(key: string): Observable<T | undefined> {
    const getPromise = new Promise(async (resolve: (value: T) => void) => {
      await this.storage.ready();
      const value = await this.storage.get(key);

      resolve(value as T);
    });

    return from(getPromise);
  }

  set(key: string, value: Object): Observable<void> {
    const setPromise = new Promise<void>(async (resolve) => {
      await this.storage.ready();
      await this.storage.set(key, value);
      resolve();
    });

    return from(setPromise);
  }
}
